import { gql, useQuery } from "@apollo/client";
import { DspType } from "graphql/types/DspType";

const GET_ALL_DSPS = gql`
    query GetAllDsps {
        allDsps : getAllDsps {
            id
            name
            dspCode
        }
    }
`;

const SEARCH_DSPS_BY_NAME = gql`
    query SearchDspsByName($keyword: String!) {
        searchDspsByName(keyword: $keyword) {
            id
            name
            dspCode
        }
    }
`;

interface GetAllDspsResponse {
    allDsps: DspType[];
}

interface SearchDspsByNameResponse {
    searchDspsByName: Pick<DspType, 'id' | 'name' | 'dspCode'>[];
}

export const useDspOptions = () => {
    const {data, loading, error} = useQuery<GetAllDspsResponse>(GET_ALL_DSPS);
    const dspOptions = data?.allDsps.map(dsp => ({value: dsp.id, label: dsp.name, dspCode: dsp.dspCode}));
    return {
        dspOptions,
        loading,
        error
    };
};

export { GET_ALL_DSPS, SEARCH_DSPS_BY_NAME };
export type { GetAllDspsResponse, SearchDspsByNameResponse };